import React, { useEffect } from 'react';

import { startsWith } from 'lodash-es';
import { useLocation } from 'react-router-dom';

import { ReactComponent as ShinroInformationIcon } from 'assets/icons/shinro-information.svg';
import NavItem from 'components/modules/mainHeader/NavItem';
import { useShinroReadStatus } from 'hooks/shinro/useShinroReadStatus';

const ShinroNavItem: React.FC = () => {
  const location = useLocation();
  const { isBadgeRead, markBadgeAsRead } = useShinroReadStatus();

  useEffect(() => {
    if (isBadgeRead) return;
    if (startsWith(location.pathname, '/shinro')) {
      markBadgeAsRead();
    }
  }, [location.pathname, isBadgeRead, markBadgeAsRead]);

  return (
    <NavItem
      icon={<ShinroInformationIcon />}
      label="進路情報"
      url="/shinro"
      active={startsWith(location.pathname, '/shinro')}
      badgeShowEmpty={!isBadgeRead}
    />
  );
};

export default ShinroNavItem;
